import React from "react"
import { MainCP } from "../../Components/percepciones-11-septiembre/MainCP"

const ViewPercepciones11Sep: React.FC = () => <MainCP/>

export default ViewPercepciones11Sep